import { Exceptionless, ExceptionlessErrorBoundary } from '@exceptionless/react'
import { PropsWithChildren, useEffect } from 'react'
import { env } from '@/env.ts'

const ExceptionlessWrapper = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    void Exceptionless.startup((c) => {
      c.apiKey = env.VITE_APP_EXCEPTIONLESS_KEY
      c.serverUrl = env.VITE_APP_EXCEPTIONLESS_URL
    })
  }, [])

  return <ExceptionlessErrorBoundary>{children}</ExceptionlessErrorBoundary>
}

export default ExceptionlessWrapper
